import { Component, OnInit, HostListener } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { T } from 'src/assets/i18n/translation-keys';

@Component({
    selector: 'app-include-images-modal',
    templateUrl: './include-images-modal.component.html',
    styleUrls: ['./include-images-modal.component.scss'],
    standalone: false
})
export class IncludeImagesModalComponent implements OnInit {
  public readonly T = T;
  public onClose: Subject<boolean> = new Subject();

  constructor(public bsModalRef: BsModalRef) {}

  ngOnInit(): void {
  }

  @HostListener('document:keydown', ['$event']) escapeAndEnterHandler(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.onInclude();
      event.preventDefault();
      event.stopPropagation();
    } else if (event.key === 'Escape') {
      this.onCancel();
    }
  }

  onInclude() {
    this.onClose.next(true);
    this.bsModalRef.hide();
  }

  onCancel() {
    this.onClose.next(false);
    this.bsModalRef.hide();
  }
}
